//React
import React, { useContext } from "react";

//Material
import {
  Grid,
  Switch,
  FormControlLabel,
  Accordion,
  AccordionDetails,
  AccordionSummary,
} from "@material-ui/core";

import { ExpandMore } from "@material-ui/icons";
import { QueryParamsContext } from "../../../../context/QueryParamsContext";

//OurComponents
import { VendedoresContext } from "../contexts/VendedoresContext";
import { HeaderAccordion } from "../styles/Vendedor";
import Chip from "../../../../components/basics/Chip";
import SelectErp from "../../../../components/basics/SelectErp";

//Controller (functions)
import useVendedorController from "../controllers/VendedorController";
import TextFieldErp from "../../../../components/basics/TextFieldErp";

const TabVendedoresGeral = () => {
  const {
    expanded,
    geralCpfcnpj,
    geralErrors,
    disabledInputCnpj,
    geralRazao,
    setGeralRazao,
    geralFantasia,
    setGeralFantasia,
    geralCep,
    setGeralCEP,
    geralEndereco,
    setGeralEndereco,
    geralNumero,
    setGeralNumero,
    geralComplemento,
    setGeralComplemento,
    geralBairro,
    setGeralBairro,
    geralEstado,
    setGeralEstado,
    geralMunicipio,
    geralPais,
    setGeralPais,
    geralTel1,
    setGeralTel1,
    geralTel2,
    setGeralTel2,
    geralTel3,
    setGeralTel3,
    geralEmail,
    setGeralEmail,
    geralComissaoVenda,
    setGeralComissaoVenda,
    geralTipoVendedor,
    setGeralTipoVendedor,
    listCommercialRegion,
    geralRegiaoComercial,
    setGeralRegiaoComercial,
    listCompanies,
    geralEmpresa,
    setGeralEmpresa,
    geralCarteiraPropria,
    setGeralCarteiraPropria,
    geralAtivo,
    setGeralAtivo,
    listUf,
    listCounty,
    listNation,
    loadingInputs,
    sellerType,
    listComissions,
    geralComission,
    setGeralComission,
    validCpfCnpj,
  } = useContext(VendedoresContext);

  const { queryParams } = useContext(QueryParamsContext);

  const {
    handleChangeOpenAccordion,
    handleChangeCep,
    handleCidade,
    handleInputUser,
  } = useVendedorController();

  // View
  return (
    <Grid item xs={12}>
      <Accordion
        expanded={expanded?.general || false}
        onChange={() => handleChangeOpenAccordion("general")}
      >
        <AccordionSummary
          expandIcon={<ExpandMore />}
          aria-controls="panel1bh-content"
          id="panel1bh-header"
        >
          <HeaderAccordion>
            <Grid container>
              <Grid item xs={12}>
                <Chip
                  bgcolor="primary"
                  textcolor="white"
                  label="DADOS GERAIS"
                />
              </Grid>
            </Grid>
          </HeaderAccordion>
        </AccordionSummary>

        <AccordionDetails>
          <Grid container spacing={3}>
            <Grid item lg={4} md={3} sm={6} xs={12}>
              <TextFieldErp
                id="geralCpfcnpj"
                label="CPF, CNPJ ou CÓD*"
                value={geralCpfcnpj}
                onChange={(e) => handleInputUser(e)}
                helperText={geralErrors.geralCpfcnpj || ""}
                error={geralErrors.geralCpfcnpj ? true : false}
                disabled={validCpfCnpj || disabledInputCnpj}
              />
            </Grid>

            <Grid item lg={4} md={6} sm={6} xs={12}>
              <TextFieldErp
                id="geralRazao"
                label="Razão / Nome*"
                value={geralRazao}
                setValue={setGeralRazao}
                helperText={geralErrors.geralRazao || ""}
                error={geralErrors.geralRazao ? true : false}
              />
            </Grid>

            <Grid item lg={4} md={6} sm={6} xs={12}>
              <TextFieldErp
                id="fantasia"
                label="Fantasia*"
                value={geralFantasia}
                setValue={setGeralFantasia}
                helperText={geralErrors.geralFantasia || ""}
                error={geralErrors.geralFantasia ? true : false}
              />
            </Grid>

            <Grid item lg={3} md={6} sm={6} xs={12}>
              <TextFieldErp
                id="geralCep"
                label="CEP"
                value={geralCep}
                setValue={setGeralCEP}
                helperText={geralErrors.geralCep || ""}
                onChange={(value) => handleChangeCep(value, "general")}
              />
            </Grid>

            <Grid item lg={4} md={6} sm={8} xs={8}>
              <TextFieldErp
                id="endereco"
                label="Endereço*"
                value={geralEndereco}
                setValue={setGeralEndereco}
                helperText={geralErrors.geralEndereco || ""}
                error={geralErrors.geralEndereco ? true : false}
              />
            </Grid>

            <Grid item lg={1} md={6} sm={4} xs={4}>
              <TextFieldErp
                id="numero"
                label="Número"
                value={geralNumero}
                setValue={setGeralNumero}
              />
            </Grid>

            <Grid item lg={4} md={6} sm={6} xs={12}>
              <TextFieldErp
                id="complemento"
                label="Complemento"
                maxLength={50}
                value={geralComplemento}
                setValue={setGeralComplemento}
              />
            </Grid>

            <Grid item lg={3} md={6} sm={6} xs={12}>
              <TextFieldErp
                id="bairro"
                label="Bairro*"
                value={geralBairro}
                setValue={setGeralBairro}
                helperText={geralErrors.geralBairro || ""}
                error={geralErrors.geralBairro ? true : false}
              />
            </Grid>

            <Grid item lg={2} md={6} sm={6} xs={12}>
              <SelectErp
                loading={loadingInputs?.listUf || false}
                id="geralEstado"
                label="Estado*"
                optionsList={listUf}
                value={geralEstado}
                setValue={setGeralEstado}
                descriptionField="estado"
                helperText={geralErrors.geralEstado || ""}
                error={geralErrors.geralEstado ? true : false}
              />
            </Grid>

            <Grid item lg={2} md={6} sm={6} xs={12}>
              <SelectErp
                id="geralMunicipio"
                loading={loadingInputs?.listCounty || false}
                label="Município*"
                value={geralMunicipio}
                onChange={handleCidade}
                optionsList={listCounty}
                descriptionField="municipio"
                helperText={geralErrors.geralMunicipio || ""}
                error={geralErrors.geralMunicipio ? true : false}
              />
            </Grid>

            <Grid item lg={2} md={6} sm={6} xs={12}>
              <SelectErp
                loading={loadingInputs?.listNation || false}
                id="geralPais"
                label="País"
                optionsList={listNation}
                value={geralPais}
                setValue={setGeralPais}
                descriptionField="descricao"
              />
            </Grid>

            <Grid item lg={3} md={6} sm={6} xs={12}>
              <TextFieldErp
                id="geralEmail"
                label="Email"
                value={geralEmail}
                setValue={setGeralEmail}
              />
            </Grid>

            <Grid item lg={3} md={6} sm={6} xs={12}>
              <TextFieldErp
                id="geralTel"
                label="Telefone 1"
                value={geralTel1}
                setValue={setGeralTel1}
                mask="cel-phone"
              />
            </Grid>

            <Grid item lg={3} md={6} sm={6} xs={12}>
              <TextFieldErp
                id="geralTel"
                label="Telefone 2"
                value={geralTel2}
                setValue={setGeralTel2}
                mask="cel-phone"
              />
            </Grid>

            <Grid item lg={3} md={6} sm={6} xs={12}>
              <TextFieldErp
                id="geralTel"
                label="Telefone 3"
                value={geralTel3}
                setValue={setGeralTel3}
                mask="cel-phone"
              />
            </Grid>

            <Grid item lg={3} md={6} sm={6} xs={12}>
              <TextFieldErp
                id="geralComissao"
                label="Comissão de Venda (%)"
                value={geralComissaoVenda}
                setValue={setGeralComissaoVenda}
                helperText={geralErrors.geralComissaoVenda || ""}
                error={geralErrors.geralComissaoVenda ? true : false}
              />
            </Grid>

            <Grid item lg={3} md={6} sm={6} xs={12}>
              <SelectErp
                loading={loadingInputs?.sellerType || false}
                id="geralTipo"
                label="Tipo"
                optionsList={sellerType}
                value={geralTipoVendedor}
                setValue={setGeralTipoVendedor}
                descriptionField="label"
              />
            </Grid>

            <Grid item lg={3} md={6} sm={6} xs={12}>
              <SelectErp
                loading={loadingInputs?.listCommercialRegion || false}
                id="geralRegiao"
                label="Região Comercial"
                optionsList={listCommercialRegion}
                value={geralRegiaoComercial}
                setValue={setGeralRegiaoComercial}
                descriptionField="descricao"
              />
            </Grid>

            <Grid item lg={3} md={6} sm={6} xs={12}>
              <SelectErp
                loading={loadingInputs?.listCompanies || false}
                id="geralEmpresas"
                label="Empresa"
                optionsList={listCompanies}
                value={geralEmpresa}
                setValue={setGeralEmpresa}
                descriptionField="apelido"
              />
            </Grid>

            {queryParams.calculacomissaopordescontomedio === "SIM" && (
              <Grid item lg={3} md={6} sm={6} xs={12}>
                <SelectErp
                  loading={loadingInputs?.listComissions || false}
                  id="geralComission"
                  label="Tabela de Comissão"
                  optionsList={listComissions}
                  value={geralComission}
                  setValue={setGeralComission}
                  descriptionField="descricao"
                />
              </Grid>
            )}

            <Grid item container spacing={3}>
              <Grid item lg={2} md={6} sm={6} xs={12}>
                <FormControlLabel
                  control={
                    <Switch
                      checked={geralCarteiraPropria}
                      onChange={() =>
                        setGeralCarteiraPropria((current) => !current)
                      }
                      color="primary"
                    />
                  }
                  label="Possui carteira própria?"
                  labelPlacement="end"
                />
              </Grid>

              <Grid item lg={1} md={6} sm={6} xs={12}>
                <FormControlLabel
                  control={
                    <Switch
                      checked={geralAtivo}
                      onChange={() => setGeralAtivo((current) => !current)}
                      color="primary"
                    />
                  }
                  label="Ativo"
                  labelPlacement="end"
                />
              </Grid>
            </Grid>
          </Grid>
        </AccordionDetails>
      </Accordion>
    </Grid>
  );
};

export default TabVendedoresGeral;
